import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';
import moment from 'moment';
import './styles/Kidola.css'; // Adjust the path as necessary

import { useNavigate } from 'react-router-dom';

const ExtraTimeDetailPage = ({ isSidebarCollapsed }) => {
    const { extraTimeId } = useParams();
    const [extraTime, setExtraTime] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchStudentDetails = async () => {
            try {
                const response = await api.get(`/teacher/extratime/detail/${extraTimeId}`);
                const extraTimeData = response.data.data || null;
                setExtraTime(extraTimeData);
            } catch (error) {
                console.error("Failed to fetch extra time details", error);
            }
        };

        fetchStudentDetails();
        
        
        
        
    }, [extraTimeId]);
   
    const handleSubmit = (status) => {
        
        const confirmation = window.confirm('Are you sure you want to proceed with this action?');
        if (!confirmation) {
            return;
        }

        const requestBody = {
            data: {
                extraTimeData: {
                    status_name: status  
                }
            }
        };

        api.put(`teacher/extratime/update/${extraTimeId}`, requestBody)
        .then(response => {
            console.log('Extra Time submitted successfully:', response.data);
            const successMessage = response.data.message;
            navigate('/success', { state: { message: successMessage } });
            
        })
        .catch(error => {
            console.error('Error adding student:', error);
            navigate('/error', { state: { message: 'Please ask to administrator!' } });
        });
    };

    if (!extraTime) return <p>Loading Extra Time details...</p>;

    return (
        <div className={`page-content ${isSidebarCollapsed ? 'collapsed' : ''} spp-payment`}>
            <div className="page-title">Extra Time Detail</div>
            <div className="form-container">
                <div className="section">
                    <h3 className="section-header">Request Data</h3>
                    <table>
                        <tbody>
                            <tr>
                                <td>Teacher Name</td>
                                <td>:</td>
                                <td>{extraTime.Teacher.teacher_name}</td>
                            </tr>
                            <tr>
                                <td>Branch</td>
                                <td>:</td>
                                <td>{extraTime.Teacher.Branch ? extraTime.Teacher.Branch.branch_name : "Central"}</td>
                            </tr>
                            <tr>
                                <td>Request Extra Time Type</td>
                                <td>:</td>
                                <td>{extraTime.Type.type_name}</td>
                            </tr>
                            <tr>
                                <td>Extra Time Date</td>
                                <td>:</td>
                                <td>{moment(extraTime.extra_time_date).format('dddd, DD MMMM YYYY')}</td>
                            </tr>
                            <tr>
                                <td>Extra Time Amount</td>
                                <td>:</td>
                                <td>{extraTime.amount}</td>
                            </tr>
                            <tr>
                                <td>Status</td>
                                <td>:</td>
                                <td>{extraTime.Status.status_name}</td>
                            </tr>
                            <tr>
                                <td>Description</td>
                                <td>:</td>
                                <td>{extraTime.description}</td>
                            </tr>
                            <tr>
                                <td>Requested On</td>
                                <td>:</td>
                                <td>{moment(extraTime.requested_on).format('DD MMMM YYYY HH:mm:ss')}</td>
                            </tr>
                            {extraTime.approved_on!=null ?
                            <tr>
                                <td>Approved On</td>
                                <td>:</td>
                                <td>{moment(extraTime.approved_on).format('DD MMMM YYYY HH:mm:ss')}</td>
                            </tr>
                            :""}
                            {extraTime.rejected_on!=null ?
                            <tr>
                                <td>Rejected On</td>
                                <td>:</td>
                                <td>{moment(extraTime.rejected_on).format('DD MMMM YYYY HH:mm:ss')}</td>
                            </tr>
                            :""}
                            {extraTime.teacher_paid_on!=null ?
                            <tr>
                                <td>Paid On</td>
                                <td>:</td>
                                <td>{moment(extraTime.teacher_paid_on).format('DD MMMM YYYY')}</td>
                            </tr>
                            :""}
                        </tbody>
                    </table>
                </div>
                {extraTime.ExtraTimeDetails.length>0 &&
                <div className="create-student-table">
                    <h3 className="section-header">Extra Time Details</h3>
                    <table>
                        <thead>
                        <tr>
                        <th className='table-center-align'>No</th>
                            <th className='table-center-align'>Start Time</th>
                            <th className='table-center-align'>Finish Time</th>
                        </tr>
                        </thead>
                        <tbody>
                        {extraTime.ExtraTimeDetails.map((detail, index) => (
                            <tr key={detail.extra_time_detail_id}>
                                <td class="no-column">{index + 1}</td>
                                <td>{detail.extra_time}.00</td>
                                <td>{detail.extra_time + 1}.00</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                }
                {extraTime.Status.status_name === "WAITING APPROVAL"?
                <div className="approve-reject-container">
                    <button className="approve-reject-button" onClick={() => handleSubmit('APPROVED')}>Approve</button>  
                    <button className="profile-button" onClick={() => handleSubmit('REJECTED')}>Reject</button>
                </div>
                :""}
                <div className="search-container">  
                    <button onClick={() => navigate(`/`)}>Back</button>
                </div>
            </div>
        </div>
    );
};

export default ExtraTimeDetailPage;
